<mat-toolbar>
  <ng-container actions>
    <mat-toolbar-row>
      <ng-container class="mat-toolbar__left">
        <div
          class="flex--column spacing--margin-right item-selector"
          *ngIf="totalAmountOfDayOldChicks$ | async as totalAmountOfDayOldChicks"
        >
          {{ 'total' | translate }}: {{ totalAmountOfDayOldChicks | agrNumber }}
        </div>
      </ng-container>

      <div class="mat-toolbar__right">
        <button mat-flat-button color="accent" (click)="add()" data-test="day-old-chick__add">
          <mat-icon>add</mat-icon>{{ 'add' | translate }}
        </button>
      </div>
    </mat-toolbar-row>
  </ng-container>
</mat-toolbar>

<ng-container [agrBlockSpinner]="(dayOldChicks$ | async) === undefined">
  <ng-container *ngIf="dayOldChicks$ | async as dayOldChicks">
    <mat-nav-list *ngIf="dayOldChicks.length" class="day-old-chick__list">
      <a
        href="#"
        mat-list-item
        class="day-old-chick-item"
        data-test="day-old-chick__item"
        [routerLink]="[dayOldChick.id]"
        *ngFor="let dayOldChick of dayOldChicks"
      >
        <mat-icon matListItemAvatar class="list-avatar" svgIcon="mdi-inbox-arrow-up"></mat-icon>
        <div matListItemTitle>
          {{ dayOldChick.arrivalDate | agrDate: 'dd-MM-yyyy' }} -
          {{ dayOldChick.amountOfChicks | agrNumber }}
          {{ dayOldChick.breed.name }}
        </div>
        <div
          matListItemLine
          [attr.data-test]="'day-old-chick-item__barn-name--' + dayOldChick.barn.name"
        >
          {{ 'barn' | translate | titlecase }} {{ dayOldChick.barn.name }}
        </div>
        @if (brandingService.isTenant('Agrifirm')) {
          <button matListItemMeta mat-icon-button (click)="delete($event, dayOldChick.id)">
            <mat-icon>delete</mat-icon>
          </button>
        } @else {
          <button
            matListItemMeta
            mat-flat-button
            class="tenant-icon-only-flat-button"
            color="primary"
            (click)="delete($event, dayOldChick.id)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </a>
      <mat-divider></mat-divider>
    </mat-nav-list>

    <agr-notification-empty
      [isEmpty]="(hasBarns$ | async) !== true"
      [emptyTitle]="'no-barns-title' | translate"
      [emptyDescription]="'add-barn-first-description' | translate"
      emptyImage="assets/images/arrival.jpg"
    >
    </agr-notification-empty>

    <agr-notification-empty
      [isEmpty]="!dayOldChicks.length && (hasBarns$ | async) === true"
      [emptyTitle]="'no-day-old-chicks-title' | translate"
      [emptyDescription]="'no-day-old-chicks-description' | translate"
      emptyImage="assets/images/arrival.jpg"
    >
    </agr-notification-empty>
  </ng-container>
</ng-container>
